import useSWRMutation, { SWRMutationConfiguration } from 'swr/mutation'
import { COMMENT_API_PREFIX } from 'shared/api/constants/api-constants'
import { adaptFetcherToSWRMutationFn } from 'shared/api/utils/adapt-fetcher-to-swr-mutation'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'

interface UsePinCommentOptions {
  commentId: number
  config?: SWRMutationConfiguration<void, Error, string, undefined>
}

export const usePinComment = ({ commentId, config }: UsePinCommentOptions) => {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.post, void, void>({
    method: RequestMethodsEnum.post,
    notFoundResponseHandler() {},
  })

  return useSWRMutation(
    `${COMMENT_API_PREFIX}/${commentId}/pin`,
    adaptFetcherToSWRMutationFn<void, undefined>(fetcher),
    config,
  )
}
